import type { TRssDirectoryCatalogStoredEntry, TRssDirectoryEntry } from '../models/rssDirectory'
import { rssDirectoryEntrySchema } from '../models/rssDirectory'
import { resolveRssLayoutForTemplate } from './rssDirectoryLayouts'
import { resolveRssDirectoryEntryLocale } from './rssDirectoryLocale'

export function materializeRssDirectoryEntry(
  stored: TRssDirectoryCatalogStoredEntry
): TRssDirectoryEntry {
  const locale = resolveRssDirectoryEntryLocale(stored)
  return rssDirectoryEntrySchema.parse({
    ...stored,
    ...locale,
    layoutId: 'story-full',
    layoutOptions: {},
    layout: resolveRssLayoutForTemplate('story-full')
  })
}

export function materializeRssDirectoryCatalog(
  stored: readonly TRssDirectoryCatalogStoredEntry[]
): readonly TRssDirectoryEntry[] {
  return stored.map(materializeRssDirectoryEntry)
}

export function listEnabledStoredEntries(
  stored: readonly TRssDirectoryCatalogStoredEntry[]
): readonly TRssDirectoryCatalogStoredEntry[] {
  return stored.filter(e => e.enabled)
}

export function listEnabledMaterializedEntries(
  stored: readonly TRssDirectoryCatalogStoredEntry[]
): readonly TRssDirectoryEntry[] {
  return materializeRssDirectoryCatalog(listEnabledStoredEntries(stored))
}

export function getStoredRssDirectoryEntry(
  id: string,
  stored: readonly TRssDirectoryCatalogStoredEntry[]
): TRssDirectoryCatalogStoredEntry | undefined {
  return stored.find(e => e.id === id)
}

export function getRssDirectoryEntryFromCatalog(
  id: string,
  catalog: readonly TRssDirectoryEntry[]
): TRssDirectoryEntry | undefined {
  return catalog.find(e => e.id === id)
}

export function isRssDirectoryEntryInCatalog(
  id: string,
  catalog: readonly TRssDirectoryEntry[]
): boolean {
  return catalog.some(e => e.id === id)
}

export function isEnabledRssDirectoryEntryId(
  id: string,
  stored: readonly TRssDirectoryCatalogStoredEntry[]
): boolean {
  const entry = getStoredRssDirectoryEntry(id, stored)
  return entry != null && entry.enabled
}

export function rssDirectoryListingSummary(entry: TRssDirectoryEntry) {
  const locale = resolveRssDirectoryEntryLocale(entry)
  return {
    id: entry.id,
    label: entry.label,
    category: entry.category,
    provider: entry.provider,
    language: locale.language,
    country: locale.country,
    layoutId: entry.layoutId,
    layoutPreview: entry.layout.name
  }
}
